import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators, ReactiveFormsModule } from '@angular/forms';

@Component({
    selector: 'app-add-pension-source',
    templateUrl: './add-pension-source.component.html',
    styleUrls: ['./add-pension-source.component.scss'],
    imports: [ReactiveFormsModule]
})
export class AddPensionSourceComponent implements OnInit {
  public addPensionpot: UntypedFormGroup;
  constructor(private fb: UntypedFormBuilder) { }

  ngOnInit() {
    this.userFormData();
  }
  userFormData = () => {
    this.addPensionpot = this.fb.group({
      fundProvider: [null,Validators.required],
      guarantees: [null, Validators.required],
      penalties: [null, Validators.required],
      fundValue: [null],
      productCode: [null],
      next: ['']
    });
  }

}
